function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["animation: ", " 1s infinite alternate;"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["animation: ", " 1s infinite alternate;"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  opacity: ", ";\n  ", "\n\n  :hover {\n    opacity: 1;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  from {\n    color: ", ";\n  }\n  to {\n    color: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  from {\n    background-color: ", ";\n  }\n  to {\n    background-color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import PropTypes from "prop-types";
import React from "react";
import styled, { css, keyframes } from "styled-components";
import "./ButtonField.css"; // #region CSS
// Animation pour la div

var alertAnimationDiv = function alertAnimationDiv(props) {
  return keyframes(_templateObject(), props.beginColor, props.endColor);
}; // Animation pour l'icône


var alertAnimationI = function alertAnimationI(props) {
  return keyframes(_templateObject2(), props.beginColor, props.endColor);
}; // css pour la div en fonction de la propriété alert


var StyledDiv = styled.div(_templateObject3(), function (props) {
  return props.opacity;
}, function (props) {
  return props.alert ? css(_templateObject4(), alertAnimationDiv(props)) : "background-color: " + props.beginColor + ";";
}); // css pour l'icône en fonction de la propriété alert

var StyledI = styled.i(_templateObject5(), function (props) {
  return props.alert ? css(_templateObject6(), alertAnimationI(props)) : "color: " + props.beginColor + ";";
}); // #endregion
// #region HOOK

/**
 * Représente un bouton contenant soit du texte, soit une icône. <br/>
 * Si la propriété _icon_ n'est pas renseignée, la propriété _tooltip_ sera affichée
 * @class
 * @category Fields
 * @param {Fields.ButtonField.propTypes} props Les propriétés du bouton
 */

function ButtonField(props) {
  // Récupération des props
  var alert = props.alert,
      backgroundColor = props.backgroundColor,
      heightButtonIcon = props.heightButtonIcon,
      icon = props.icon,
      iconColor = props.iconColor,
      iconSize = props.iconSize,
      onClick = props.onClick,
      opacity = props.opacity,
      tooltip = props.tooltip,
      widthButtonIcon = props.widthButtonIcon;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledDiv, {
    className: icon ? "ButtonField" : "ButtonField ButtonField-Text",
    alert: alert,
    beginColor: backgroundColor,
    endColor: iconColor,
    opacity: opacity,
    "data-tip": tooltip,
    "data-for": "DefaultTooltip",
    onClick: onClick,
    style: icon ? {
      width: widthButtonIcon,
      height: heightButtonIcon
    } : null
  }, icon ? /*#__PURE__*/React.createElement(StyledI, {
    className: "ButtonField-Icon fas fa-" + icon,
    alert: alert,
    beginColor: iconColor,
    endColor: backgroundColor,
    style: {
      fontSize: iconSize
    }
  }) : /*#__PURE__*/React.createElement("div", {
    style: {
      color: iconColor,
      fontSize: iconSize,
      padding: "6px",
      width: "fit-content"
    }
  }, tooltip)));
} // #endregion
// #region PROPRIETES

/**
 * Type des propriétés de {@link ButtonField}
 * @typedef {Object} ButtonField.propTypes
 * @property {function} onClick La fonction de callback de l'évènement onClick
 * @property {string} tooltip Le texte du bouton
 * @property {string} [icon=null] Icône du bouton
 * @property {string} [backgroundColor=#000] La couleur de fond
 * @property {string} [iconColor=#fff] La couleur de l'icône
 * @property {string} [iconSize=1.6em] La taille de l'icône ou de la police
 * @property {string} [widthButtonIcon=44px] La largeur du bouton, uniquement quand _icon_ ne vaut pas null
 * @property {string} [heightButtonIcon=44px] La hauteur du bouton, uniquement quand _icon_ ne vaut pas null
 * @property {boolean} [alert=false] true pour que le message soit modal
 * @property {number} [opacity=1] Opacité du bouton
 */


ButtonField.propTypes = process.env.NODE_ENV !== "production" ? {
  onClick: PropTypes.func.isRequired,
  tooltip: PropTypes.string.isRequired,
  icon: PropTypes.string,
  backgroundColor: PropTypes.string,
  iconColor: PropTypes.string,
  iconSize: PropTypes.string,
  widthButtonIcon: PropTypes.string,
  heightButtonIcon: PropTypes.string,
  alert: PropTypes.bool,
  opacity: PropTypes.number
} : {};
/*
  Valeurs par défaut des propriétés
*/

ButtonField.defaultProps = {
  icon: null,
  backgroundColor: "#000",
  iconColor: "#fff",
  iconSize: "1.6em",
  widthButtonIcon: "44px",
  heightButtonIcon: "44px",
  alert: false,
  opacity: 1
}; // #endregion

export { ButtonField };